import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@components/ui/button/button.tsx";
import { useTranslations } from "@hooks/use-translations.ts";
import { Header } from "@components/ui/header.tsx";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index() {
  const { translate } = useTranslations();
  return (
    <div className="w-full flex motion-safe:[view-transition-name:main-content] text-background dark:text-foreground">
      <div className="absolute h-dvh w-dvw select-none">
        <img
          srcSet={`${translate("index.landing-image.1080w")} 1.5x, ${translate("index.landing-image.1440w")} 2x`}
          src={translate("index.landing-image.720w")}
          alt="Windfarm background image"
          className="w-full h-full object-cover"
        />
        <div className="w-full h-full bg-gradient-to-b from-[#003A5C] to-[rgba(0,0,0,0)] absolute top-0 left-0" />
      </div>
      <div className="relative flex flex-col h-dvh mx-auto max-w-[120rem] px-4 md:px-16 lg:px-24">
        <Header light className="sticky top-0 pt-4 lg:pt-8">
          {translate("calculator.title")}
        </Header>
        <div className="flex flex-row my-auto">
          <div className="flex flex-col gap-8 justify-center lg:basis-2/3 items-center lg:items-start text-center lg:text-start motion-safe:animate-[fade-slide-in-top_700ms_ease-in-out]">
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold">
              {translate("index.title")}
            </h1>
            <p className="text-lg lg:text-xl md:max-w-2/3">
              {translate("index.hook")}
            </p>
            <Link
              preload="render"
              to="/calculator"
              viewTransition={{ types: ["slide-left"] }}
            >
              <Button>{translate("index.estimate-your-savings")}</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
